import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=51cda058&scoped=true&"
import script from "./auction.vue?vue&type=script&lang=js&"
export * from "./auction.vue?vue&type=script&lang=js&"
import style0 from "./auction.vue?vue&type=style&index=0&id=51cda058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cda058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cda058')) {
      api.createRecord('51cda058', component.options)
    } else {
      api.reload('51cda058', component.options)
    }
    module.hot.accept("./auction.vue?vue&type=template&id=51cda058&scoped=true&", function () {
      api.rerender('51cda058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/auction.vue"
export default component.exports